import { LitElement, html } from "lit-element";
import "./tone-viz";

class MidiContainer extends LitElement {
  static get properties() {
    return {
      availableInputs: { type: Array },
      value: { type: Number },
    };
  }

  constructor() {
    super();

    this.value = 0;

    const createLoop = () => {
      let up = true;
      return () => {
        new Tone.Loop((time) => {
          if (up && this.value < 100) {
            this.value++;
          } else if (up && this.value === 100) {
            up = !up;
          } else if (!up && this.value > 1) {
            this.value--;
          } else {
            this.value = 0;
            up = true;
          }
        }, "100n").start(0);
      };
    };

    const loop = createLoop();
    loop();
  }

  render() {
    return html`
      <tone-viz
        name="horizontal"
        position="absolute"
        origin="bottom"
        transportNoteSpeed="50n"
        numNotes="32"
        noteFadeSpeed="2"
        size="1"
        mode="sequential-position"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="top"
        transportNoteSpeed="50n"
        numNotes="32"
        noteFadeSpeed="2"
        size="1"
        mode="sequential-position"
        startColor="rgb(0, 0, 100)"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="bottom"
        noteWidthOrigin="right"
        transportNoteSpeed="100n"
        numNotes="64"
        noteFadeSpeed=".5"
        size="1"
        mode="sequential-position"
        noteWidth="${this.value}"
        width="100%"
        height="100%"
        backgroundColor="transparent"
        startColor="rgb(255, 255, 0)"
        endColor="rgb(200, 200, 0)"
        noteOpacity="1"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        origin="bottom"
        transportNoteSpeed="100n"
        numNotes="64"
        noteFadeSpeed=".5"
        size="1"
        mode="sequential-position"
        noteWidth="${this.value}"
        width="100%"
        height="100%"
        backgroundColor="transparent"
        startColor="rgb(255, 255, 0)"
        endColor="rgb(200, 200, 0)"
        noteOpacity="1"
      ></tone-viz>
    `;
  }
}

customElements.define("midi-container", MidiContainer);
